import cn from 'classnames';
import React from 'react';
import { useLocale } from 'src/hooks/use-locale';
import { CurrencyType } from 'src/types/currency';

import styles from './Currency.css';

export const Currency = ({ currency }: { currency: CurrencyType }) => {
  const t = useLocale();

  const currencyTranslate = {
    [CurrencyType.KWD]: t('KWD'),
    [CurrencyType.BHD]: t('BHD'),
    [CurrencyType.QAR]: t('QAR'),
  };
  const currencyText =
    currency === CurrencyType.AED || currency === CurrencyType.SAR
      ? currency
      : currencyTranslate[currency];

  return (
    <span
      className={cn(styles.Currency, {
        [styles.Currency_aed]: currency === CurrencyType.AED,
        [styles.Currency_sar]: currency === CurrencyType.SAR,
      })}
      data-test={`${currency.toLowerCase()}-currency-text`}
      data-currency={currency}
    >
      {currencyText}
    </span>
  );
};
